<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
import type { Schemas } from '@shopware/api-client/api-types';

const props = defineProps<{
    element: Schemas['CmsSlot'];
}>();

const elementConfig = useCmsElementConfig(props.element);
const { getCmsLink } = useFormatCmsLink();

const headline = elementConfig.getConfigValue('heading');
const buttonText = elementConfig.getConfigValue('button');
const link = await getCmsLink(elementConfig.getConfigValue('url'));
</script>

<template>
    <div>
        
<FormKitLazyProvider config-file="true">
<h2 class="text-3xl font-extrabold leading-9 md:text-5xl md:leading-[4rem]">
            {{ headline }}
        </h2>

        <LocaleLink
            v-if="buttonText && link"
            :to="link"
            class="max-w-max"
        >
            <FormKit
                type="button"
                :label="buttonText"
                :classes="{
                    input: 'font-bold text-lg text-white !bg-neutral-800 max-w-max mt-4 md:mt-8',
                }"
            />
        </LocaleLink>
</FormKitLazyProvider>

    </div>
</template>
